import { createApp } from 'vue'
import App from './App.vue'

import router from './router';
import VueAxios from 'vue-axios';
import axios from '@/components/axios';
import {VueCookieNext} from 'vue-cookie-next';
import qs from 'qs';

import JLAlert from '@/components/jl-alert';
import JLButton from '@/components/jl-button';
import VueParticles from 'vue-particles';

import mitt from 'mitt';
const emitter = mitt();

import '@mdi/font/css/materialdesignicons.min.css';
import './assets/bootstrap.min.css';

import VTooltip from 'v-tooltip'

const title = process.env.VUE_APP_APPNAME;

router.beforeEach((to, from, next) => {
    document.title = (to.meta.title ? to.meta.title : title);
    if(to.meta.auth == true && (!VueCookieNext.isCookieAvailable(process.env.VUE_APP_COOKIEAUTH) || !VueCookieNext.isCookieAvailable(process.env.VUE_APP_COOKIEXID)) ) {
        return next('/');
    }
    else if(to.meta.auth == false && VueCookieNext.isCookieAvailable(process.env.VUE_APP_COOKIEAUTH) && VueCookieNext.isCookieAvailable(process.env.VUE_APP_COOKIEXID)) {
        document.title = title;
        return next('/dashboard');
    }
    return next();
});

const app = createApp(App);

app.config.globalProperties.appname = title;
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$qs = qs;
app.config.globalProperties.$emitter = emitter;

app.use(VTooltip);
app.use(VueParticles);
app.use(VueAxios, axios);
app.use(VueCookieNext);
app.use(JLAlert);
app.use(JLButton);
app.use(router);

app.mount('#app');
